
WL.registerComponent('news-screen', {},{
	init: function(){
		console.log("news screen started");
		PP.RightGamepad.registerButtonEventListener(PP.ButtonType.SELECT, PP.ButtonEvent.PRESS_START, 0, () => {
      		this.object.getComponent('mesh').destroy();
      		PP.RightGamepad.unregisterButtonEventListener(PP.ButtonType.SELECT, PP.ButtonEvent.PRESS_START, 0)	
      	})

      	PP.LeftGamepad.registerButtonEventListener(PP.ButtonType.SELECT, PP.ButtonEvent.PRESS_START, 0, () => {
      		this.object.getComponent('mesh').destroy();
      		PP.LeftGamepad.unregisterButtonEventListener(PP.ButtonType.SELECT, PP.ButtonEvent.PRESS_START, 0)	
      	})

	},
	start: function(){

	},
    update: function() {
         
    },
});
